<!--  推荐菜 商家介绍下面是用 -->
<template>
<div class="dish-min">
    <div class="dish-head">
        <div class="title">推荐菜</div>
        <el-button plain icon="el-icon-plus" size="mini" @click="addSuggestDishStatus=true">添加</el-button>
    </div>
    <div class="filter">
        <div class="item" :class="{active:dishParams.typeIdList.length == 0}" @click="filterChange(0)">全部</div>
        <div class="item" v-for="item in dishClassList" :key="item.id" :class="{active:dishParams.typeIdList.includes(item.id)}" @click="filterChange(item.id)">{{ item.name }}</div>
    </div>
    <div class="info-list">
        <div class="item" v-for="item in dishList" :key="item.id" @click="showDishImg(item)">

            <RecommendDishItem  :dish="item" />
        </div>
        
    </div>
    <div class="paging" style="text-align:center">
        <el-pagination
            background
            @current-change="pageChange"
            layout="prev, pager, next"
            :page-size="dishParams.size"
            :hide-on-single-page="true"
            :total="dishTotal">
        </el-pagination>
    </div>
    <div class="no-data" v-if="!postLoading && dishList.length==0">
        <img :src="require('@/assets/images/common/no-data.png')" alt="">
        <div class="note">暂没有数据</div>
    </div>
    <AddSuggestDishDialog :status.sync="addSuggestDishStatus" :info="post" />
    <el-image style="width:0; height:0" ref="elImgPrev" :src="onlyImgList[0]"  :preview-src-list="onlyImgList"></el-image>
</div>
</template>
<script>
import AddSuggestDishDialog from './add-suggest-dish-dialog.vue'
import RecommendDishItem from './recommend-dish-item.vue'
export default {
    name:'RecommendDishPage',
    props:['post'],
    components:{
        AddSuggestDishDialog,
        RecommendDishItem,
    },
    data(){
        return {
            addSuggestDishStatus:false,
            dishList:[],
            dishClassList:[],
            dishParams:{
                "postId": "",
                "typeIdList": [],
                "offset": 1,
                "size": 100
            },
            dishTotal:1,
            onlyImgList:[''],
            postLoading:true,
        }
    },
    created(){
        this.dishParams.postId = this.post.id;
        this.getClass();
        this.getList();
    },
    methods:{
        filterChange(id){
            if( id == 0 ){
                this.dishParams.typeIdList = [];
            }else{
                this.dishParams.typeIdList = [id]
            }
            this.getList();
        },
        pageChange(index){
            this.dishParams.offset = index;
            this.getList();
        },
        async getClass(){
            let result = await this.$axios.post('/comment/frontend/v1/get/dish/type/list/of/post',{postId:this.post.id})
            
            if( result.code == 0 ){
                this.dishClassList = result.data.types;
            }
        },
        async getList(){
            this.postLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/get/dish/list/of/post',this.dishParams);
            this.postLoading = false;
            if( result.code == 0 ){
                this.dishList = result.data.dishList;
                
                this.dishTotal = result.data.dishTotal;
            }
        },
        showDishImg(dishData){
            this.onlyImgList = dishData.imageList;
            
            this.$refs['elImgPrev'].clickHandler();
        }
    }
}
</script>
<style lang="scss" scoped>
.dish-min{
    margin-top: 20px; 
    .dish-head{
        display: flex; justify-content: space-between; margin-bottom: 10px;
        .title{font-size: 16px; line-height: 30px; font-weight: 400;}
    }
    .filter{
        display: flex; 
        .item{
            font-size: 14px; line-height: 30px; padding: 0 10px; border: 1px solid #dcdfe6; color: #606266; border-radius: 4px; margin-right: 10px;
            user-select: none; cursor: pointer;
            &:hover{
                background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
            }
            &.active{
                background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
            }
        }
    }
    .info-list{
        display: flex; margin: 20px -15px 0;  flex-wrap: wrap;
        .item{
            width:20%; padding: 0 15px; box-sizing: border-box; margin-bottom: 20px;
            
        }
    }
}
.no-data{
    padding: 20px 0; text-align: center;
    img{display: block; margin:0 auto;}
    .note{font-size: 14px; color: #ccc; margin-top: 15px;}
}
</style>
